import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Dropdown,
} from 'react-bootstrap';
import Select from 'react-select';
import { openModal } from '../../actions/modal.action';
import { useParams } from 'react-router-dom';
import { getSectionNameByCodeAndSurvey } from '../../actions/helpers/section.helper';

const MoveQuestionToSection = () => {
    const dispatch = useDispatch();
    const { id: surveyId } = useParams();
    const { surveys } = useSelector((state) => state.surveySummary);
    const { allSections } = useSelector((state) => state.sections);
    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);

    const handleSectionChange = (selectedOption) => {
        setSelectedSection(selectedOption);
    };

    const onMoveHandle = () => {
        openModal({
            className: 'modal-alert-width',
            button1Text: 'Cancel',
            button1Action: 'closeModal',
            button2Text: 'Move',
            button2Action: () => {
                console.log('Selected Section:', selectedSection);
            },
            body: <>
                <Select
                    isClearable
                    className="w-100"
                    placeholder="Select Original Author"
                    isSearchable
                    closeMenuOnSelect={true}
                    options={sections.map((section) => ({
                        label: `${section.code} - ${section.name}`,
                        value: section.code,
                    }))}
                    onChange={handleSectionChange}
                />
            </>,
        })(dispatch);
    };


    useEffect(() => {
        if (surveyId && surveys?.length) {
            const survey = surveys.find((s) => Number(s.id) === Number(surveyId));
            if (survey) {
                const sections = survey.surveySummaryDetailsDto?.sectionCodes
                    .split(',')
                    .sort((a, b) => {
                        if (a === b) {
                            return 0;
                        }
                        return a < b ? -1 : 1;
                    })
                    .map((code) => {
                        const selectedSectionCode = code.trim().toLowerCase();
                        const sectionName = getSectionNameByCodeAndSurvey(
                            selectedSectionCode,
                            survey,
                            allSections
                        );
                        return {
                            name: sectionName,
                            code: selectedSectionCode,
                        };
                    });
                setSections(sections);
            } else {
                setSections([]);
            }
        }
    }, [surveyId, surveys, allSections]);

    return (
        <Dropdown.Item onClick={onMoveHandle}> Edit Question </Dropdown.Item>
    );
};

export default MoveQuestionToSection;
